import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PillMenu({ items, activeId, onSelect, className, }) {
    return (_jsx("nav", { className: className, "aria-label": "Section navigation", style: {
            display: "flex",
            gap: 8,
            overflowX: "auto",
            scrollbarWidth: "none",
            paddingBottom: 2,
        }, children: items.map((item) => {
            const isActive = item.id === activeId;
            return (_jsxs("button", { onClick: () => onSelect(item.id), "aria-current": isActive ? "true" : undefined, "aria-label": item.count !== undefined
                    ? `${item.label} (${item.count})`
                    : item.label, style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "6px 16px",
                    borderRadius: 999,
                    border: isActive ? "1px solid var(--border)" : "1px solid transparent",
                    background: isActive ? "var(--panel)" : "transparent",
                    color: isActive ? "var(--brand, #1d4ed8)" : "var(--muted)",
                    fontFamily: "inherit",
                    fontSize: 13,
                    fontWeight: isActive ? 700 : 500,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    transition: "color 0.12s ease, background 0.12s ease",
                    outline: "none",
                }, onFocus: (e) => {
                    e.currentTarget.style.outline =
                        "2px solid var(--brand, #1d4ed8)";
                }, onBlur: (e) => {
                    e.currentTarget.style.outline = "none";
                }, children: [item.label, item.count !== undefined && (_jsx("span", { "aria-hidden": "true", style: {
                            minWidth: 18,
                            height: 18,
                            padding: "0 5px",
                            borderRadius: 999,
                            background: isActive ? "var(--brand, #1d4ed8)" : "var(--warn, #d97706)",
                            color: "#fff",
                            fontSize: 10,
                            fontWeight: 800,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }, children: item.count }))] }, item.id));
        }) }));
}
//# sourceMappingURL=PillMenu.js.map